// extracted by mini-css-extract-plugin
export var errorIcon = "_j5-1";
export var nameLogo = "_j5-0";